const STORAGE_PREFIX = 'shiplab.setupPopup.completed:';

const storageKey = (username: string) => `${STORAGE_PREFIX}${username}`;

export const isSetupPopupCompleted = (username?: string | null): boolean => {
  if (!username || typeof window === 'undefined') {
    return false;
  }
  try {
    return window.localStorage.getItem(storageKey(username)) === 'true';
  } catch {
    return false;
  }
};

export const markSetupPopupCompleted = (username?: string | null): void => {
  if (!username || typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(storageKey(username), 'true');
  } catch {
    // Ignore quota / private-mode failures; the popup can still hide for this session.
  }
};
